import controller from './thing-details-labels.controller';

const template = require('./thing-details-labels.html');

export default {
    bindings: {
        labels: '<',
        preUpdate: '&',
        onUpdate: '&'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/thing-details-labels/thing-details-labels.component.js